import { InveniasListTypes, InveniasNamespace } from 'datasource-service-lib';
import { IDataSourceApiService, IEntity, IFileDataSourceApiService } from 'interfaces-lib';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPreMergeChecker } from '../../interfaces/ipremergechecker';
import { MergeBasketViewComponent } from '../../merge-basket-view/merge-basket-view.component';
import { DocumentClientDatasourceApiListServiceFactory } from '../datasource/document-client-datasource-list.service';
import { ServiceProviderService } from '../service.provider.service';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

export class InveniasPreMergeCheck implements IPreMergeChecker {
  private dataSourceApiService: IDataSourceApiService;
  readonly fileDataSourceApiService: IFileDataSourceApiService;

  constructor(serviceProviderService: ServiceProviderService, sharedServiceProvider: SharedServiceProviderServiceFactory) {
    this.dataSourceApiService = serviceProviderService.getDataSourceApiService(InveniasNamespace.name);
    this.fileDataSourceApiService = sharedServiceProvider.getServiceProviderService(InveniasNamespace.name).getFileDataSourceApiService();
  }

  check(entity: IEntity, filename: string): Observable<boolean> {
    return DocumentClientDatasourceApiListServiceFactory.instance
      .create(InveniasNamespace.name, this.dataSourceApiService)
      .list({ entity: entity, associatedType: InveniasListTypes.Documents })
      .pipe(
        map((documents) => {
          return documents.find((doc) => doc.name === filename) === undefined;
        })
      );
  }

  checkFilesExist(files: any[]): Observable<any[]> {
    const files$: Observable<{ ok: boolean; file: any }>[] = [];
    files.forEach((file) => {
      if (file.type === MergeBasketViewComponent.LOCAL_FILE) {
        files$.push(of({ ok: true, file }));
      } else if (file.type === MergeBasketViewComponent.DOCUMENT) {
        files$.push(
          this.fileDataSourceApiService.checkFile(file.id).pipe(
            map((ok) => {
              return { ok, file };
            })
          )
        );
      } else {
        throw new Error(`File type '${file.type}' not recognised for file: ${file.name}`);
      }
    });

    return forkJoin(files$).pipe(map((results) => results.filter((r) => !r.ok).map((r) => r.file)));
  }
}
